import { type CSSProperties, useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { TField } from '@timeedit/types';
import { Icon } from '@timeedit/ui-components';
import { Typography } from '@timeedit/ui-components/antd';

const SortableFieldRow = ({ field }: { field: TField }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: field.id });

  const style = useMemo<CSSProperties>(
    () => ({
      transform: CSS.Translate.toString(transform),
      transition,
      ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
      cursor: 'move',
      display: 'grid',
      gridTemplateColumns: '32px repeat(2, 1fr)',
      gap: '4px',
      overflowY: 'auto',
      padding: '4px',
      borderBottom: '1px solid black',
    }),
    [transform, transition, isDragging]
  );

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Icon id="HolderOutlined" alt="Holder" />
      <Typography.Text>{field.name}</Typography.Text>
      <Typography.Text>{field.extId}</Typography.Text>
    </div>
  );
};

export default SortableFieldRow;
